import vSelect from 'vue-select'
import { BIconClipboard } from 'bootstrap-vue'
import FiatApis from '@/modules/crypto/services/apis/fiat'
import BankAccountDetails from '@/modules/crypto/components/BankAccountDetails.vue'
import { numberWithCommas, toFixed } from '@/utils'
import DescriptionApis from '@/services/apis/description'

const description = new DescriptionApis()

const fiat = new FiatApis()
export default {
  name: 'FiatMemoDeposit',
  components: {
    vSelect,
    BIconClipboard,
    BankAccountDetails,
  },
  data() {
    return {
      helpers: {
        numberWithCommas,
        toFixed,
      },
      bankAccountInfo: null,
      // 4. Deposit history (should be fetched from API)
      currencyList: [],
      bankList: [],
      currency: null,
      bankAccount: null,
      depositHistory: [
      ],

      copyTooltip: this.$t('copy'),
      show: false,
      headDescription: '',
      footerDescription: '',
    }
  },
  computed: {
    historyFields() {
      return [
        { key: 'created_at', label: this.$t('date') },
        { key: 'amount', label: this.$t('amount') },
        { key: 'currency.name', label: this.$t('currency') },
        { key: 'automation.status', label: this.$t('status') },
      ]
    },
  },
  async mounted() {
    this.show = true
    await this.getCurrencyList()
    await this.getDepositHistory()
    this.headDescription = await this.getDescription('crypto-fiat_deposit_memo_head')
    this.footerDescription = await this.getDescription('crypto-fiat_deposit_memo_footer')
    this.show = false
  },
  methods: {
    async getCurrencyList() {
      // Fetch the currency list from the API
      await fiat.getCurrency().then(async response => {
        this.currencyList = response.data.results
        const [firstCurrency] = this.currencyList
        this.currency = firstCurrency
        await this.getBankList(firstCurrency.id)
      }).finally(() => {

      })
    },
    async  getBankList(currencyId) {
      // Fetch the bank list from the API
      await fiat.bankAccountInfo({ currency_id: currencyId, type: 'memo' }).then(response => {
        this.bankList = response.data.results
        const [firstBank] = this.bankList
        this.bankAccount = firstBank
      }).catch(() => {
        this.bankAccount = null
      })
    },
    async getDepositHistory() {
      // Fetch deposit history from the API
      await fiat.getDeposits().then(response => {
        this.depositHistory = response.data.data
      }).catch(() => {
        this.depositHistory = []
      })
    },
    copyMemo() {
      // Copy the memo to clipboard
      if (navigator && navigator.clipboard) {
        navigator.clipboard.writeText(this.bankAccount.memo).then(() => {
          this.copyTooltip = this.$t('copied')
        })
      } else {
        // Fallback for older browsers
        const input = this.$refs.memoInput
        if (input && input.select) {
          input.select()
          document.execCommand('copy')
          this.copyTooltip = this.$t('copied')
        }
      }
      setTimeout(() => {
        this.copyTooltip = this.$t('copy')
      }, 1200)
    },
    async getDescription(key) {
      // Fetch the description for the memo deposit
      return await description.get({ name: key }).then(res => res.data.results.value)
    },
  },
}
